import { any, complement, equals, filter, join, pipe, split } from 'ramda';
import { isTruthy } from 'ramda-adjunct';
import { Key } from 'ts-keycode-enum';

import { callOrUse } from '../callOrUse';

export const getKeyComb = (event: KeyboardEvent): string => {
  const { ctrlKey, shiftKey, metaKey, altKey, keyCode } = event;
  const possibleKeys = [(ctrlKey || metaKey) && Key.Ctrl, altKey && Key.Alt, shiftKey && Key.Shift, keyCode];

  return pipe<Key[], Key[], string>(filter(isTruthy), join('+'))(possibleKeys);
};

export const isTargetInputField = (event: KeyboardEvent | MouseEvent): boolean => {
  const { tagName, type } = event.target as HTMLInputElement;
  return tagName === 'TEXTAREA' || (tagName === 'INPUT' && (!type || type === 'text'));
};
export const isTargetNotInputField = complement(isTargetInputField);

type TOnHotKeys = (
  keyComb: string | Key,
  handler: (event: KeyboardEvent) => void,
  shouldPreventDefault?: ((event: KeyboardEvent) => boolean) | boolean,
) => (event: KeyboardEvent) => void;

export const onHotKeys: TOnHotKeys =
  (keyComb, handler, shouldPreventDefault = true) =>
  (event) => {
    const isMatchedComb = pipe<string | Key, string, string[], boolean>(
      String,
      split('|'),
      any(equals(getKeyComb(event))),
    )(keyComb);

    if (!isMatchedComb) {
      return;
    }

    if (isTargetInputField(event)) {
      // Prevent calling handler if user is editing text inside input field.
      // This required for example when user edits folder name in "Move To" modal and we don't want Expander to appear when user press space.
      return;
    }

    if (callOrUse(shouldPreventDefault, event)) {
      event.preventDefault();
    }

    handler(event);
  };

export const stopPropagation = (event) => event.stopPropagation();
export const preventDefault = (event) => event.preventDefault();
